import { render, staticRenderFns } from "./ConfigurationForm.vue?vue&type=template&id=5a81bfea"
import script from "./ConfigurationForm.vue?vue&type=script&lang=js"
export * from "./ConfigurationForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationForm.vue?vue&type=style&index=0&id=5a81bfea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports